export const messages = {
  "no id found": "Sorry, we can't find the id of this item. Please go back to the list and select this item again",
  "something_went_wrong": "Sorry, something went wrong. Please contact the support staff for further assistance",
};